export const EFFECTS = [
  { title: 'Dissolve', value: 'Dissolve' },
  { title: 'Fader', value: 'Fader' },
  { title: 'Inchworm', value: 'Inchworm' },
  // { title: 'Kaleidoscope', value: 'Kaleidoscope' },
  { title: 'Magnify', value: 'Magnify' },
  { title: 'Plane', value: 'Plane' },
  { title: 'Swirl', value: 'Swirl' },
  // { title: 'Vortex', value: 'Vortex' },
];